// material-ui
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

// project imports
import Chip from 'ui-component/extended/Chip';
import { useEffect, useState } from 'react';
import EmptyTable from 'ui-component/EmptyTable';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { SkuHC } from 'types/components/shared';
import { styled } from '@mui/system';

// ===========================|| DATA WIDGET - PROJECT TABLE CARD ||=========================== //

const TableUpdates = ({ updates }: { updates: SkuHC[] }) => {
    const intl = useIntl();
    const [emptyTable, setEmptyTable] = useState<Boolean>(true);

    useEffect(() => {
        if (updates?.length) {
            setEmptyTable(false);
            return;
        }
        setEmptyTable(true);
    }, [updates]);

    return (
        <>
            {updates && updates?.length > 0 && (
                <>
                    <PerfectScrollbar
                        style={{
                            height: '100%',
                            maxHeight: 'calc(100vh - 205px)',
                            overflowX: 'hidden'
                        }}
                    >
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ pl: 3 }}>
                                            <FormattedMessage id="sku_name" />
                                        </TableCell>
                                        <TableCell>
                                            <FormattedMessage id="reference_code" />
                                        </TableCell>
                                        <TableCell>EAN / UPC</TableCell>
                                        <TableCell align="right" sx={{ pr: 3 }}>
                                            <FormattedMessage id="date_insert" />
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody sx={{ overflow: 'scroll' }}>
                                    {Boolean(updates?.length) &&
                                        updates?.map((row, index) => (
                                            <TableRow hover key={index}>
                                                <TableCellStyled sx={{ maxWidth: 140 }} title={row?.skuName ?? ''}>
                                                    {row?.skuName}
                                                </TableCellStyled>
                                                <TableCellStyled sx={{ maxWidth: 110 }} title={row?.skuReferenceCode ?? ''}>
                                                    {row?.skuReferenceCode}
                                                </TableCellStyled>
                                                <TableCellStyled sx={{ maxWidth: 110 }} title={row?.eanUpc ?? ''}>
                                                    {row?.eanUpc}
                                                </TableCellStyled>
                                                <TableCell align="right" sx={{ pr: 3 }}>
                                                    {row?.dateInsert && (
                                                        <Chip
                                                            title={intl.formatDate(row?.dateInsert ?? '', {
                                                                dateStyle: 'full',
                                                                timeStyle: 'medium'
                                                            })}
                                                            size="small"
                                                            chipcolor="primary"
                                                            label={intl.formatDate(row?.dateInsert ?? '', {
                                                                dateStyle: 'short',
                                                                timeStyle: 'medium'
                                                            })}
                                                        />
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </PerfectScrollbar>

                    {emptyTable && <EmptyTable messageId="no_recent_updates" />}
                </>
            )}
        </>
    );
};

export default TableUpdates;

const TableCellStyled = styled(TableCell)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
